import { ThemeContext } from "@emotion/react";
import { AddCircle, Edit, FilePresent, Save } from "@mui/icons-material";
import { Alert, CircularProgress, Grid, IconButton, TextField, Tooltip } from "@mui/material";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { CreateRevisiones, GetPartesRevisiones, UpdateRevision } from "../../../../hooks/partesRevisiones";
import swal from "sweetalert2";
import { ModalArchivosRevisiones } from "./modales/modalArchivos";
import { useLoading } from "../../../../components/Loading/useLoading";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";


export const RevisionesParte = ({ part_id, part_nombre }) => {

  const theme = useContext(ThemeContext);
  const selectPermission = (state) => state.auth.permissions;
  const selectPermissions = createSelector(
    [selectPermission],
    (permissions) => ({ permissions })
  );
  const { permissions } = useSelector(selectPermissions);
  let can_edit = permissions?.some(objeto => objeto.permissionKey === 'MRP:Inventario:PartesRevisiones:Editar');

  const { isLoading, isError, data, refetch } = GetPartesRevisiones(part_id);
  const { updateRevisionMutation } = UpdateRevision()
  const { createRevisionesMutation } = CreateRevisiones()
  const [revisiones, setRevisiones] = useState([]);
  const [revision, setRevision] = useState(null);
  const [update, setUpdate] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const { setAppLoading } = useLoading();

  // Cuando se cargan los datos, inicializamos el estado local
  useEffect(() => {
    if (data) setRevisiones(data);
  }, [data]);

  const handleInputChange = (e, id) => {
    const newRevisiones = [...revisiones];
    newRevisiones[id][e.target.name] = e.target.value;
    setRevisiones(newRevisiones);
  };

  const addRevision = () => {
    let nueva = {
      pare_id: revisiones[0] !== null ? revisiones[0]?.pare_id + 1 : revisiones.length + 1,
      pare_nombre: '',
      pare_numerodibujo: '',
      pare_fechadibujo: '',
      pare_cambioingenieria: '',
      nuevo: true
    }
    setRevisiones((rev) => [...rev, nueva])
  }

  const saveRevisiones = () => {
    let nuevas_revisiones = revisiones.filter(rev => rev.nuevo);
    let body = {
      part_id,
      part_nombre,
      data: nuevas_revisiones
    }
    createRevisionesMutation(body, {
      onSuccess: (data) => {
        swal
          .fire({
            position: "top-end",
            icon: data?.success ? "success" : "error",
            title: data?.mensaje,
            showConfirmButton: false,
            timer: 1500,
          })
      },
      onError: (error) => {
        swal
          .fire({
            position: "top-end",
            icon: "error",
            title: data?.mensaje,
            showConfirmButton: false,
            timer: 1500,
          })
        setAppLoading(false);
      },
      onSettled: () => {
        setAppLoading(false);
        refetch();
      }
    })
  }

  const openResources = (rev) => {
    setRevision(rev);
    setOpenModal(true);
  }

  const closeModal = () => {
    setOpenModal(false);
    setRevision(null)
  }

  const openEdit = (pare_id) => {
    setUpdate(pare_id);
  }

  const closeEdit = () => {
    let rev = revisiones.find(rev => rev?.pare_id === update);
    updateRevisionMutation({ id: rev?.pare_id, data: rev }, {
      onSuccess: (data) => {
        swal
          .fire({
            position: "top-end",
            icon: data?.success ? "success" : "error",
            title: data?.mensaje,
            showConfirmButton: false,
            timer: 1500,
          })
      }, onError: (error) => {
        swal
          .fire({
            position: "top-end",
            icon: "error",
            title: data?.mensaje,
            showConfirmButton: false,
            timer: 1500,
          })
      },
      onSettled: () => {
        setUpdate(null);
        refetch();
      }
    })
  }


  return (
    <>
      {/* ENCABEZADO */}
      <Grid item xs={12} sx={{ p: 0, mt: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} >
        <div>
          <span style={{ fontWeight: 600, color: theme.palette.primary.title }}>
            Revisiones
          </span>
          {
            can_edit &&
            <IconButton onClick={addRevision} disabled={isError || isLoading}>
              <AddCircle sx={{ color: theme.palette.primary.main, ml: 1 }} />
            </IconButton>
          }

        </div>
        {
          can_edit &&
          <Tooltip title="Guardar">
            <IconButton aria-label="delete" onClick={saveRevisiones} disabled={update}>
              <Save />
            </IconButton>
          </Tooltip>
        }
      </Grid>
      {/* DATOS */}
      {revisiones.length > 0 &&
        <>
          {revisiones?.map((rev, index) => (
            <>
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3} sx={{ p: 0, mb: 1, pr: 1 }} >
                <TextField
                  id={`revision${rev?.pare_id}`}
                  label="Revisión"
                  fullWidth
                  size="small"
                  value={rev?.pare_nombre}
                  name="pare_nombre"
                  disabled={!rev?.nuevo && update !== rev?.pare_id}
                  sx={{ color: theme.palette.primary.input }}
                  onChange={(e) => handleInputChange(e, index)}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2} lg={2} xl={2} sx={{ p: 0, mb: 1, pr: 1 }} >
                <TextField
                  id={`dibujo${rev?.pare_id}`}
                  label="No. de dibujo"
                  fullWidth
                  size="small"
                  value={rev.pare_numerodibujo}
                  name="pare_numerodibujo"
                  disabled={!rev?.nuevo && update !== rev?.pare_id}
                  sx={{ color: theme.palette.primary.input }}
                  onChange={(e) => handleInputChange(e, index)}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3} sx={{ p: 0, mb: 1, pr: 1 }} >
                <TextField
                  id={`fecha${rev?.pare_id}`}
                  type="date"
                  fullWidth
                  size="small"
                  value={moment(rev?.pare_fechadibujo).format('yyyy-MM-DD')}
                  name="pare_fechadibujo"
                  hiddenLabel
                  placeholder=""
                  disabled={!rev?.nuevo && update !== rev?.pare_id}
                  sx={{ color: theme.palette.primary.input }}
                  className="input-date"
                  onChange={(e) => handleInputChange(e, index)}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2} lg={2} xl={2} sx={{ p: 0, mb: 1, pr: 1 }} >
                <TextField
                  id={`cambio${rev?.pare_id}`}
                  label="Cambio de ingenieria"
                  fullWidth
                  size="small"
                  value={rev?.pare_cambioingenieria}
                  name="pare_cambioingenieria"
                  disabled={!rev?.nuevo && update !== rev?.pare_id}
                  sx={{ color: theme.palette.primary.input }}
                  onChange={(e) => handleInputChange(e, index)}
                />
              </Grid>
              {
                !rev?.nuevo && can_edit &&
                <Grid item xs={6} sm={6} md={2} lg={2} xl={2} sx={{ p: 0, mb: 1, pr: 1, display: 'flex', gap: 2 }} >
                  {
                    update !== rev?.pare_id &&
                    <Tooltip title="Editar" placement="top">
                      <IconButton aria-label="delete" onClick={() => openEdit(rev?.pare_id)} disabled={update}>
                        <Edit />
                      </IconButton>
                    </Tooltip>
                  }
                  {
                    update === rev?.pare_id &&
                    <Tooltip title="Guardar" placement="top">
                      <IconButton aria-label="delete" onClick={closeEdit}>
                        <Save />
                      </IconButton>
                    </Tooltip>
                  }
                  <Tooltip title="Archivos adjuntos" placement="top">
                    <IconButton aria-label="delete" onClick={() => openResources(rev)}>
                      <FilePresent />
                    </IconButton>
                  </Tooltip>
                </Grid>
              }
            </>
          ))}
        </>
      }
      {/* CARGANDO SECCION */}
      {
        isLoading &&
        <Grid item xs={12} sx={{ p: 0, mt: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
          <CircularProgress />
        </Grid>
      }
      {/* ALERTA VACIO */}
      {
        data?.length === 0 && revisiones.length === 0 &&
        <Grid item xs={12} sx={{ p: 0, mt: 3, display: 'flex', alignItems: 'center' }} >
          <Alert severity="warning" sx={{ width: '100%' }}>No existen revisiones en esta parte</Alert>
        </Grid>
      }
      {/* ALERTA ERROR */}
      {isError &&
        <Grid item xs={12} sx={{ p: 0, mt: 3, display: 'flex', alignItems: 'center' }} >
          <Alert severity="error" sx={{ width: '100%' }}>No se pudieron cargar las revisiones</Alert>
        </Grid>
      }´
      {/* MODAL DE REVISIONES */}
      {
        revision &&
        <ModalArchivosRevisiones key='modal_revisiones' open={openModal} handleClose={closeModal} revision={revision} />
      }
    </>
  )

}